import React from "react";
import { Select } from "antd";
import useGuildRoles from "../Members/useGuildRoles";

export const RolePicker: React.FC<{
  roleCallback: (roleId: string) => void;
}> = ({ roleCallback }) => {
  const guildId: string = localStorage.getItem("guild-id") || "";
  const { data: guildRoles } = useGuildRoles(guildId);

  return (
    <Select
      showSearch
      placeholder={"Select a role"}
      onChange={roleCallback}
      defaultValue={null}
      filterOption={(input, option) => {
        return option?.["name"].toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      optionFilterProp="name"
      style={{ width: "12rem" }}
    >
      {guildRoles.map((role, index) => (
        <Select.Option
          id={index}
          key={role.discord_id}
          value={role.discord_id}
          name={role.name}
        >
          {role.name}
        </Select.Option>
      ))}
    </Select>
  );
};
